<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.GIVE_BACK
      }}</span>
      <div class="close-button custom-pointer" @click="close()">
        <b-icon icon="close" />
      </div>
    </header>
    <div class="modal-content-container">
      <section class="spacing-p-10">
        <span class="has-text-color-7 has-text-weight-semibold">{{
          General.JUSTIFICATION
        }}</span>
        <b-field class="description">
          <b-input
            v-model="justification"
            maxlength="500"
            type="textarea"
            iconClickable
          />
        </b-field>

        <section>
          <table
            class="table has-text-black custom-overflow"
            :title="General.TEXTS.SIGNATURE_LIST"
            :aria-describedby="General.TEXTS.SIGNATURE_LIST"
          >
            <thead>
              <tr>
                <th class="has-text-color-8 is-size-7">{{ General.NUP }}</th>
                <th class="has-text-color-8 is-size-7">
                  {{ General.SUBJECT.toUpperCase() }}
                </th>
                <th class="has-text-color-8 is-size-7">
                  {{ General.TO.toUpperCase() }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(row, id) in listProcess" :key="id">
                <td class="has-text-color-8 is-size-7">
                  {{ applyMaskNUP(row.nup) }}
                </td>
                <td>
                  <div class="has-text-color-8 is-size-7">
                    {{ row.subject_name }}
                  </div>
                </td>
                <td class="has-text-color-8 is-size-7">
                  {{ row.from_capacity }}
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </section>

      <footer class="modal-card-foot is-justify-content-flex-end">
        <div class="buttons">
          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            @click="giveBack"
          >
            {{ General.GIVE_BACK.toUpperCase() }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white-dark' : 'is-primary'"
            outlined
            @click="close"
          >
            {{ General.CANCEL.toUpperCase() }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { General, App } from "@/utils/constants";
import modalGiveBackConfirmation from "@/views/App/ModalGiveBackConfirmation";
import { NUP, applyMask } from "@/utils/protocols";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ModalGiveBack",
  props: {
    listProcess: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      General,
      App,
      justification: General.TEXTS.DEFAULT_RETURN_TEXT,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      user: "getCurrentUser",
      isContrast: "isContrast"
    })
  },
  methods: {
    ...mapActions({
      returnProcess: "returnProcessRequest"
    }),
    async giveBack() {
      this.isLoading = true;
      if (!this.justification.length)
        this.snackToast.open({
          message: `${this.General.TEXTS.EMPTY_JUSTIFICATION}!`,
          type: "is-danger",
          duration: 8000
        });
      else {
        const msg = [];
        if (!this.justification.length)
          msg.push(this.General.TEXTS.EMPTY_JUSTIFICATION);
        if (!this.listProcess.length)
          msg.push(this.General.MESSAGES.NO_RECORDS_FOUND);

        if (msg.length) {
          this.snackToast.open({
            message: `${msg.join(", ")}.`,
            type: "is-danger",
            duration: 8000
          });
        } else {
          const listProcessReturn = this.listProcess.map(proc => ({
            process_id: proc.id,
            justification: this.justification
          }));

          const status = await this.returnProcess(listProcessReturn);

          if (status) {
            await this.$store.dispatch("processCapacityListRequest", {
              capacityId: this.user.capacity.capacity_id,
              page: 1,
              order_by: JSON.stringify({ last_tramited_date_es: "desc" })
            });

            await this.$store.dispatch("myProcessListRequest", {
              page: 1,
              order_by: JSON.stringify({
                user_responsible_date: { order: "desc", unmapped_type: "date" }
              })
            });

            this.close();

            this.$buefy.modal.open({
              parent: this,
              component: modalGiveBackConfirmation,
              props: {
                listProcess: this.listProcess
              },
              hasModalCard: true,
              trapFocus: true
            });
          }
        }
      }
      this.isLoading = false;
    },

    close() {
      this.$parent.close();
    },

    applyMaskNUP(value) {
      return applyMask(NUP, value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.close-button {
  z-index: 2;
}

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-height: 75vh;
  background-color: $color-1;
  font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}

.spacing-mt-5.columns {
  margin-left: 0px;
  margin-right: 10px;
}

.spacing-mb-20 {
  margin-bottom: 10px !important;
}

.custom-overflow {
  height: 110px;
  overflow-y: auto;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}

table tbody tr:hover {
  background-color: transparent !important;
}
</style>
